import { passportConfidenceFields } from 'utils/constants/documents';
import { MARITAL_STATUS_IDS, PASSPORT_CONFIDENCE_ERRORS } from './MainAnketa.constants';
import { DOCUMENTS_TYPES } from './components/FileUpload/FileUpload.constants';
import { MESS_SERNUMBER_MVD } from 'utils/validationUtils/messages';

export const isPersonMarried = (person) =>
  person?.personalInfo?.familyState?.id === MARITAL_STATUS_IDS.MARRIED_PERSON;

export const isCustomerMarried = (customer) =>
  customer.personalInformation && customer.personalInformation.maritalStatusSysName === 'married';

export const isDocumentExists = (documents, docType = [DOCUMENTS_TYPES.PASSPORT]) =>
  documents?.some((document) => docType.includes(document?.type?.sysName)) ?? false;

export const isDocumentClassExists = (
  documents,
  docType = [DOCUMENTS_TYPES.PASSPORT_MAIN, DOCUMENTS_TYPES.PASSPORT_MAIN_HANDWRITTEN]
) => {
  if (!documents) return false;
  for (let doc of documents) {
    if (doc.classification && docType.includes(doc.classification.type)) {
      return true;
    }
  }
  return false;
};

export const getPassportConfidenceErrors = (documents) => {
  const result = {};

  documents?.forEach((document) => {
    const isPassportDoc = document?.type?.id === 30;
    const isValidClassification = [
      DOCUMENTS_TYPES.PASSPORT_MAIN,
      DOCUMENTS_TYPES.PASSPORT_REGISTRATION,
    ].includes(document?.classification?.type);
    const hasConfidenceData = Object.keys(document?.recognition?.confidence || {}).length > 0;

    if (!isPassportDoc || !isValidClassification || !hasConfidenceData) {
      return;
    }

    const docType = document.classification.type;
    const confidenceFields = passportConfidenceFields[docType];

    if (!confidenceFields) {
      return;
    }

    Object.entries(document.recognition.confidence).forEach(([field, confidence]) => {
      const fieldConfig = confidenceFields[field];

      if (fieldConfig && confidence < fieldConfig.confidence) {
        result[fieldConfig.field] = result[fieldConfig.field] || 'Проверьте данное поле';
      }
    });
  });

  return result;
};

export const isPassportConfidenceCorrect = (documents) => {
  if (!documents) {
    return null;
  }

  return Object.keys(getPassportConfidenceErrors(documents)).length === 0;
};

export const hasPassportConfidenceErrors = (confidenceErrors) => {
  if (!confidenceErrors || Object.keys(confidenceErrors).length === 0) {
    return false;
  }

  const passportErrorValues = Object.values(PASSPORT_CONFIDENCE_ERRORS);

  return Object.keys(confidenceErrors).some((errorKey) => passportErrorValues.includes(errorKey));
};

export const getMvdError = (errors) => {
  return errors[PASSPORT_CONFIDENCE_ERRORS.SERIA_NUMBER] === MESS_SERNUMBER_MVD
    ? MESS_SERNUMBER_MVD
    : false;
};
